// ABOUTME: Screen 5C Guiding Truth: the storm's guiding truth in a card under the sky, with Let Go, Together on the plate.
// ABOUTME: let_go_together sends nothing; the server sets Kala and moves to 5D, and the eyebrow and rail come from progress.

import { useCrossingContent } from '../../../hooks/useCrossingContent';
import type { ScreenProps, ScreenResult } from '../runner/screenContract';
import GuidingTruthCard from './sky/GuidingTruthCard';
import { guidingTruthFor, stormNameFor } from './sky/guidingTruth';

export default function Screen5C({ crossing }: ScreenProps): ScreenResult {
  const { data: content } = useCrossingContent();
  const storm = crossing.storm ? content?.storms[crossing.storm] : undefined;

  return {
    layer: <GuidingTruthCard stormName={stormNameFor(storm, crossing.storm)} truth={guidingTruthFor(storm, crossing.storm)} />,
    sceneSky: 'forgiven',
    headline: 'The lesson stays raised. The rest can be set down when ready.',
  };
}
